import { AntenaGrupoFormType } from './AntenaGrupoFormType';

export const createAntenaGrupoFormInitialValues = (): AntenaGrupoFormType => ({
  nombre: ''
});
